import Dialog from "@components/Dialog";
import { googleContext } from "@layouts/App/context/Google";
import { type ParentComponent, Show, splitProps, useContext } from "solid-js";
import TracklistMap from "./components/Map";
import type { LocationProps } from "./types";

const Location: ParentComponent<LocationProps> = (props) => {
	const [local, others] = splitProps(props, ["children", "triggerW"]);
	const google = useContext(googleContext);

	return (
		<Dialog openTrigger={local.children} triggerW={local.triggerW}>
			<Show when={google.map} keyed>
				{(map) => <TracklistMap {...others} mapLibrary={map} />}
			</Show>
		</Dialog>
	);
};
export default Location;
